<template>
  <!--<el-card shadow="never"-->
           <!--class="aui-card&#45;&#45;fill">-->
  <div class="pkg-search-box">
    <el-form class="pkg-content" :model="siteDetailForm"
             :rules="dataRule"
             ref="siteDetailForm">
      <div class="location-layout">
        <el-row>
          <!--场地编号-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.code')"
                          prop="siteNo">
              <el-input v-model="siteDetailForm.siteNo"
                        :placeholder="$t('res.site.code')"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!--场地名称-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.ChineseName')"
                          prop="siteCnName">
              <el-input v-model="siteDetailForm.siteCnName"
                        maxlength="255"
                        :disabled="true"
                        :placeholder="$t('res.site.ChineseName')"></el-input>
            </el-form-item>
          </el-col>
          <!--场地简称-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.shortName')"
                          prop="siteAbbr">
              <el-input v-model="siteDetailForm.siteAbbr"
                        maxlength="255"
                        :disabled="true"
                        :placeholder="$t('res.site.shortName')"></el-input>
            </el-form-item>
          </el-col>
          <!--场地英文名称-->
          <!--<el-col :span="8">-->
          <!--<el-form-item :label="$t('res.site.EnglishName')"-->
          <!--prop="siteEnName">-->
          <!--<el-input v-model="siteDetailForm.siteEnName"-->
          <!--maxlength="255"-->
          <!--:disabled="true"-->
          <!--:placeholder="$t('res.site.EnglishName')"></el-input>-->
          <!--</el-form-item>-->
          <!--</el-col>-->
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--场地分类-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.classification')"
                          prop="siteClassId">
              <class-tree ref="classRef"
                          :disabled="true"
                          v-on:getSelectList="getSelectList"
                          v-bind:defaultProps="defaultProps"
                          v-bind:url="queryTreeUrl"
                          v-bind:showArray="siteDetailForm.showSiteClassList"
                          v-bind:showValue="siteDetailForm.showValue"
                          v-bind:isSelect=true
                          v-bind:filterText="'10'"
                          v-bind:status="'siteClassStatus'"></class-tree>
            </el-form-item>
          </el-col>
          <!--所在城市-->
          <el-col :span="8"
                  class="padt8">
            <el-form-item prop="cityId">
              <span slot="label"><span style="color:red;font-size:9px;">*&nbsp;</span>{{$t('res.site.city')}}</span>
              <class-tree ref="cityClassRef"
                          :disabled="true"
                          v-on:getSelectList="getcitySelectList"
                          v-bind:defaultProps="citydefaultProps"
                          v-bind:url="queryCityTreeUrl"
                          v-bind:showArray="siteDetailForm.showCityClassList"
                          v-bind:showValue="siteDetailForm.showCityValue"
                          v-bind:isSelect=true></class-tree>
            </el-form-item>
          </el-col>
          <!--所属分类-->
          <el-col :span="8">
            <el-form-item prop="siteType"
                          :label="$t('res.site.type')">
              <el-select v-model="siteDetailForm.siteType"
                         :disabled="true"
                         @change=add
                         :placeholder="$t('res.site.type')"
                         clearable>
                <el-option v-for="(item,index) in typeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--所属公司-->
          <el-col :span="8">
            <el-form-item prop="companyId">
              <span slot="label"><span style="color:red;font-size:9px;">*&nbsp;</span>{{$t('res.site.company')}}</span>
              <el-select clearable
                         v-model="siteDetailForm.companyId"
                         :placeholder="$t('res.site.selectType')"
                         :disabled="true">
                <el-option v-for="item in companyList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--场地状态-->
          <el-col :span="8">
            <el-form-item prop="status"
                          :label="$t('res.site.status')">
              <el-select :disabled="true"
                         v-model="siteDetailForm.status"
                         :placeholder="$t('res.site.status')"
                         clearable>
                <el-option v-for="(item,index) in statusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--联系人-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.contacts')"
                          prop="contactPerson">
              <el-input v-model="siteDetailForm.contactPerson"
                        maxlength="20"
                        :disabled="true"
                        :placeholder="$t('res.site.contacts')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--场地地址-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.address')"
                          prop="address">
              <el-input v-model="siteDetailForm.address"
                        maxlength="255"
                        :disabled="true"
                        :placeholder="$t('res.site.address')"></el-input>
            </el-form-item>
          </el-col>
          <!--联系电话-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.telephone')"
                          prop="phone">
              <el-input v-model="siteDetailForm.phone"
                        maxlength="20"
                        :disabled="true"
                        :placeholder="$t('res.site.telephone')"></el-input>
            </el-form-item>
          </el-col>
          <!--开始时间-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.startTime')"
                          prop="startTime">
              <el-date-picker :disabled="true"
                              v-model="siteDetailForm.startTime"
                              :placeholder="$t('res.site.startTime')"
                              type="date"
                              value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--结束时间-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.endTime')"
                          prop="endTime">
              <el-date-picker :disabled="true"
                              :picker-options="checkEndTime"
                              v-model="siteDetailForm.endTime"
                              :placeholder="$t('res.site.endTime')"
                              type="date"
                              value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col>
          <!--餐饮费用-->
          <el-col :span="8">
            <el-form-item :label="$t('res.site.cateringExpenses')"
                          prop="cateringExpenses"
                          maxlength="10">
              <el-input v-model="siteDetailForm.cateringExpenses"
                        :disabled="true"
                        :placeholder="$t('res.site.cateringExpenses')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <br>
    <br>
    <!--<h3>{{ $t('res.cri.tag') }}</h3>-->
    <div class="pkg-content">
      <h3>{{ $t('res.cri.tag') }}</h3>
      <el-form label-position="top"
             label-width="145px"
             :ref="dataForm"
             ref="dataForm">
      <div>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="tagName"
                          style="width: 100%!important;">
              <tag :checkedList="checkList"
                   :moduleId="moduleId"
                   :overLabelShow = "false"
                   :closeShow = "false"
                   :bussinessTypeId = "bussinessTypeId"
                   :brandCode="bussinessTypeChecked"
                   @getBussinessType="getBussinessType"
                   @changeCheckedList="changeCheckedList"
                   ref='tagTree'
                   @fatherMethod="fatherMethod"></tag>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    </div>
    <br>
    <br>
    <div class="pkg-content">
      <div v-if="isShowClassroomTable">
      <!--教室信息-->
      <el-table :data="dataList"
                border
                stripe
                v-loading="dataListLoading"
                style="width: 100%;">
        <!-- 序号 -->
        <el-table-column  prop="xh"
                         type="index"
                         header-align="center"
                         align="center"
                         width="50"
                         :index="indexCreate"
                         :label="$t('res.cri.serialNo')">
        </el-table-column>
        <!-- 教室编号 -->
        <el-table-column prop="classroomNo"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.classroomNo')">
        </el-table-column>
        <!-- 教室名称 -->
        <el-table-column prop="roomCnName"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.roomCnName')">
        </el-table-column>
        <!-- 教室简称 -->
        <el-table-column prop="roomCnAbbr"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.roomCnAbbr')">
        </el-table-column>
        <!-- 所属场地 -->
        <el-table-column prop="siteCnName"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.subordinateSite')">
        </el-table-column>
        <!-- 教室分类 -->
        <el-table-column prop="roomClassCnName"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.classroomClass')">
        </el-table-column>
        <!-- 教室标签 -->
        <!--<el-table-column prop="roomTag"-->
                         <!--header-align="center"-->
                         <!--align="center"-->
                         <!--:label="$t('res.cri.roomTag')">-->
        <!--</el-table-column>-->
        <!-- 状态 -->
        <el-table-column prop="status"
                         :formatter="statusFormatter"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.status')">
        </el-table-column>
        <!-- 是否统计 -->
        <el-table-column prop="ifCount"
                         :formatter="ifCountFormatter"
                         header-align="center"
                         align="center"
                         :label="$t('res.cri.ifCount')">
        </el-table-column>
        <!-- 是否有教室布局文件 -->
        <!--<el-table-column prop="isUpload"-->
                         <!--header-align="center"-->
                         <!--align="center"-->
                         <!--width="180"-->
                         <!--:label="$t('res.cri.file')">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button v-if="scope.row.isUpload === '10'"-->
                       <!--size="mini"-->
                       <!--type="text"-->
                       <!--@click="downloadFile(scope.row)">{{ $t('res.vehinfo.yes') }}</el-button>-->
            <!--<span v-if="scope.row.isUpload === '20'">{{ $t('res.vehinfo.no') }}</span>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    </div>
    <br>
    <div class="pkg-content">
      <div class="btn-position-up"
         style="text-align:right;">
      <!--编辑按钮-->
      <el-button type="primary"
                 v-if="$hasPermission('AUTHSITEINF0006')"
                 @click="editSiteInfo()">{{ $t('res.vehinfo.edit') }}</el-button>
      <!--返回-->
      <el-button type="info"
                 @click="backPage()">{{ $t('res.vehinfo.back') }}</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import AddressSelect from '@/components/address-select'
import ClassTree from '@/components/rm/class-tree/index'
import mixinViewModule from '@/mixins/view-module'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'

export default {
  mixins: [mixinViewModule],
  data () {
    var integerVali = (rule, value, callback) => {
      if (!value) {
        return callback()
      }
      let reg = /^\d+(\.\d+)?$/
      // if (!Number.isInteger(value)) {
      if (!reg.test(value)) {
        callback(new Error(this.$t('res.cri.r.nonnegativeFloat')))
      } else {
        callback()
      }
    }
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/classroominfo/list',
        getDataListIsPage: true
      },
      visible: false,
      // 是否显示教室table
      isShowClassroomTable: true,
      dataForm: {
        siteIdList: []
      },
      siteDetailForm: {
        id: 0,
        siteNo: '',
        siteCnName: '',
        // siteEnName: '',
        siteAbbr: '',
        cityId: '',
        siteType: '',
        companyId: '',
        siteClassId: '',
        labelId:'',
        status: '10',
        contactPerson: '',
        address: '',
        phone: '',
        startTime: new Date(),
        endTime: '',
        cateringExpenses: '',
        version: '',
        showValue: '',
        showSiteClassList: [],
        showCityValue: '',
        showCityClassList: [],
        siteClassType: ''
      },
      // 标签数据
      tagTableData: [{
        tagType: '车辆',
        tagContent: '汽车发动机'
      }, {
        tagType: '车辆',
        tagContent: '汽车变速箱'
      }, {
        tagType: '车辆',
        tagContent: 'cess'
      }],
      companyList: [],
      statusArr: this.enums['status'], // 状态
      typeArr: this.enums['orgType'], // 状态
      dataRule: {
        // siteNo: [
        //   { required: true, message: this.$t('res.site.code') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ],
        siteCnName: [
          { required: true, message: this.$t('res.site.ChineseName') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        // siteEnName: [
        //   { required: true, message: this.$t('res.site.EnglishName') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ],
        siteAbbr: [
          { required: true, message: this.$t('res.site.shortName') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        // cityId: [
        //   { required: true, message: this.$t('res.site.city') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ],
        siteType: [
          { required: true, message: this.$t('res.site.type') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        // companyId: [
        //   { required: true, message: this.$t('res.site.company') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ],
        siteClassId: [
          { required: true, message: this.$t('res.site.classification') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        status: [
          { required: true, message: this.$t('res.site.status') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('res.site.startTime') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        cateringExpenses: [
          { validator: integerVali, trigger: 'blur' }
          // { type: 'number', message: this.$t('res.cri.site.cateringExpenses'), trigger: 'blur' }
          // { required: true, message: this.$t('res.site.cateringExpenses') + this.$t('res.site.notNull'), trigger: 'blur' }
        ]
      },
      // 场地分类
      defaultProps: {
        children: 'children',
        label: 'siteClassCnName'
      },
      queryTreeUrl: '/rm/siteclass/list',
      // 城市分类
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      // 校验结束时间
      checkEndTime: this.checkSiteInfoEndTime(),
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 8,
      bussinessTypeChecked: 8,
      // 操作类型 新增/修改
      operationType: '',
      siteId: '',
      saveType: '',
      // 场地分类
      addType: false,
      // 场地分类类型
      siteClassType: '',
      siteClassId: '',
      siteClassCnName: '',
      siteClassList: [],
      // 城市显示名称
      citySingleName: '',
      // 教室信息
      dataList: [],
      dataListLoading: false
    }
  },
  mounted () {
    this.initMethod()
    this.$eventHub.$on(this.GLOBAL.SITE_INFO, (data) => {
      this.initMethod()
    })
  },
  components: {
    AddressSelect,
    Tag,
    'class-tree': ClassTree
  },
  methods: {
    // 生成网格的序号
    indexCreate (index) {
      return (this.page - 1) * this.limit + (index + 1)
    },
    // 页面打开初始化方法
    initMethod () {
      // 清空城市树
      // this.$refs.cityClassRef && this.$refs.cityClassRef.resetChecked()
      // // 清空场地分类树
      // this.$refs.classRef && this.$refs.classRef.resetChecked()
      // this.$nextTick(() => {
      //   this.$refs['siteDetailForm'] && this.$refs['siteDetailForm'].resetFields()
      // })
      // 获取公司信息
      this.queryCompany(this.$route.query.siteId)
      // 操作类型赋值
      this.operationType = this.$route.query.operationType
      this.addType = false
      this.dataForm.siteIdList = []
      if (this.$route.query.id !== undefined) {
        this.siteDetailForm.id = this.$route.query.id
        this.dataForm.siteIdList.push(this.$route.query.id)
        this.isShowClassroomTable = true
        this.getInfo()
        // 查询教室信息
        this.getDataList()
      } else {
        this.isShowClassroomTable = false
      }
    },
    // 查询公司下拉选
    queryCompany (val) {
      // 获取公司下拉框数据
      if (val !== '' && val !== undefined) {
        console.info(val)
        this.$request.get(`/rm/company/info`, { 'orgTypeList': val }).then((data) => {
          let arr = []
          data.forEach(function (item) {
            let param = { value: item.orgId, label: item.nameCn }
            arr.push(param)
          })
          this.companyList = arr
        })
      }
    },
    // 获取信息s
    getInfo () {
      this.$request.get(`/rm/siteinfo/info/${this.siteDetailForm.id}`).then((data) => {
        console.info('123456')
        console.info(data)
        console.info('456789')
        this.siteClassType = data.siteClassType
        this.siteClassId = data.siteClassId
        this.siteClassCnName = data.siteClassCnName
        this.siteClassList.push(data.siteClassId)
        if (String(data.siteClassType) === '2') {
          this.addType = true
        } else {
          this.addType = false
        }
        this.siteDetailForm.siteNo = data.siteNo
        this.siteDetailForm.siteCnName = data.siteCnName
        // this.siteDetailForm.siteEnName = data.siteEnName
        this.siteDetailForm.siteAbbr = data.siteAbbr
        this.siteDetailForm.cityId = data.cityId
        this.siteDetailForm.siteType = data.siteType
        this.siteDetailForm.companyId = data.companyId
        this.siteDetailForm.siteClassId = data.siteClassId
        this.siteDetailForm.status = data.status
        this.siteDetailForm.contactPerson = data.contactPerson
        this.siteDetailForm.address = data.address
        this.siteDetailForm.phone = data.phone
        this.siteDetailForm.startTime = data.startTime
        this.siteDetailForm.endTime = data.endTime ? data.endTime.substring(0, 10) : ''
        this.siteDetailForm.cateringExpenses = data.cateringExpenses
        this.siteDetailForm.creator = data.creator
        this.siteDetailForm.createDate = data.createDate
        this.siteDetailForm.updater = data.updater
        this.siteDetailForm.updateDate = data.updateDate
        this.siteDetailForm.version = data.version
        // 场地分类的回填
        this.siteDetailForm.showValue = data.siteClassCnName
        this.siteDetailForm.showSiteClassList = []
        this.siteDetailForm.showSiteClassList.push(data.siteClassId)
        // 城市分类的回填
        this.siteDetailForm.showCityValue = data.citySingleName
        this.siteDetailForm.showCityClassList = []
        this.siteDetailForm.showCityClassList.push(data.cityId)
        // this.dataList = data.classroomInfoVoList
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameCn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameEn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        }
      })
    },
    // 表单提交
    dataFormSubmitHandle () {
      this.$refs['siteDetailForm'].validate((valid) => {
        if (valid) {
          let url = ''
          let param = ''
          if (String(this.siteClassType) === '1') {
            if (this.siteDetailForm.cityId === '' || this.siteDetailForm.cityId === null) {
              this.$message.warning(this.$t('res.cri.site.cityIdNull'))
              return false
            }
            if (this.siteDetailForm.companyId === '' || this.siteDetailForm.companyId === null) {
              this.$message.warning(this.$t('res.cri.site.companyIdNull'))
              return false
            }
          }
          url = `/rm/siteinfo/${!this.siteDetailForm.id ? 'save' : 'update'}`
          param = {
            'id': this.siteDetailForm.id || undefined,
            // 'siteNo': this.siteDetailForm.siteNo,
            'siteCnName': this.siteDetailForm.siteCnName,
            // 'siteEnName': this.siteDetailForm.siteEnName,
            'siteAbbr': this.siteDetailForm.siteAbbr,
            'cityId': this.siteDetailForm.cityId,
            'siteType': this.siteDetailForm.siteType,
            'companyId': this.siteDetailForm.companyId,
            'siteClassId': this.siteDetailForm.siteClassId,
            'status': this.siteDetailForm.status,
            'contactPerson': this.siteDetailForm.contactPerson,
            'address': this.siteDetailForm.address,
            'phone': this.siteDetailForm.phone,
            'startTime': this.siteDetailForm.startTime,
            'endTime': this.siteDetailForm.endTime,
            'cateringExpenses': this.siteDetailForm.cateringExpenses
          }
          this.$request.post(
            url,
            param
          ).then((data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.saveType = 'saveSeccess'
                this.$refs.cityClassRef.resetChecked()
                this.$refs.classRef.resetChecked()
                this.addType = false
                // this.$router.go(-1)
              }
            })
          })
        }
      })
    },
    // 返回按钮
    backPage () {
      this.$router.go(-1)
    },
    // 编辑跳转按钮
    editSiteInfo () {
      let _this = this
      // _this.$confirm(_this.$t('trainer.cancelinfo'), _this.$t('prompt.title'), {
      //   confirmButtonText: _this.$t('confirm'),
      //   cancelButtonText: _this.$t('cancel'),
      //   type: 'warning'
      // }).then(() => {
        _this.tabRemove()
        let query = {}
        let name = 'rm-siteinfo-add-or-update'
        query.id = this.siteDetailForm.id
        query.type = 'update'
        query.operationType = 'update'
        query.siteId = this.siteDetailForm.siteType
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.SITE_INFO, '')
      // })
    },
    // 创建教室
    createClassroom (row) {
      let name = 'rm-classroominfo-add-or-update'
      let query = {}
      query.type = row
      query.siteCnName = this.siteDetailForm.siteCnName
      query.cateringExpenses = this.siteDetailForm.cateringExpenses
      query.siteId = this.siteDetailForm.id
      this.$router.push({
        name: name,
        query: query
      })
    },
    getSelectList (args) {
      if (args && args !== '' && args.length > 0) {
        if (this.operationType === 'add') {
          this.siteDetailForm.siteClassType = args[0].siteClassType
          this.siteClassType = args[0].siteClassType
          this.siteDetailForm.siteClassId = args[0].id
          if (String(args[0].siteClassType) === '2') {
            this.siteDetailForm.cityId = ''
            this.$refs.cityClassRef.resetChecked()
            this.siteDetailForm.companyId = ''
            this.companyList = []
            this.siteDetailForm.address = ''
            this.addType = true
          } else {
            this.addType = false
          }
        }
        if (this.operationType === 'update') {
          if (String(this.siteClassType) !== String(args[0].siteClassType)) {
            this.$message.warning(this.$t('res.cri.site.siteClass'))
            this.$refs.classRef.resetChecked()
            this.siteDetailForm.siteClassId = this.siteClassId
            this.$nextTick(() => {
              this.siteDetailForm.showValue = this.siteClassCnName
              this.siteDetailForm.showSiteClassList = JSON.parse(JSON.stringify(this.siteClassList))
            })
          } else {
            this.siteClassId = args[0].id
            this.siteClassCnName = args[0].siteClassCnName
            this.siteClassList = []
            this.siteClassList.push(args[0].id)
          }

          this.siteDetailForm.siteClassId = args[0].id
        }
      } else {
        this.siteDetailForm.siteClassId = ''
      }
    },
    getcitySelectList (args) {
      if (args && args !== '' && args.length > 0) {
        this.siteDetailForm.cityId = args[0].id
      } else {
        this.siteDetailForm.cityId = ''
      }
    },
    // 校验结束时间
    checkSiteInfoEndTime () {
      return {
        disabledDate: function disabledDate (time) {
          return new Date().getTime() > time.getTime()
        }
      }
    },
    add (value) {
      this.siteDetailForm.companyId = ''
      if (value === '' && value === undefined) {
        this.companyList = []
      }
      this.queryCompany(value)
    },
    // 教室信息
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 是否转换
    ifCountFormatter (row) {
      return Vue.filter('coverEnum')(row.ifCount, 'confirmState')
    },
    // 下载文件
    downloadFile (row) {
      let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/file/file/fastDownload'
      let dlform = document.createElement('form')
      dlform.method = 'post'
      dlform.action = requestUrl
      let hdnFilePath = document.createElement('input')
      hdnFilePath.type = 'hidden'
      hdnFilePath.name = 'id'
      hdnFilePath.value = row.fileId
      dlform.appendChild(hdnFilePath)
      document.body.appendChild(dlform)
      dlform.submit()
      document.body.removeChild(dlform)
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = 3
      this.bussinessTypeId = 3
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameCn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameCn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameCn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      } else {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameEn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameEn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameEn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      }
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang="css" scoped>
  /* 模拟部分的el-card样式 */
  .pkg-search-box {
    color: #303133;
    transition: 0.3s;
    border-radius: 4px;
    overflow: hidden;
  }
  .pkg-content {
    background-color: #fff;
    padding: 20px;
  }
  /* icon style */
  .pkg-icon-button {
    display: inline-block;
    padding: 0 20px;
    font-size: 20px;
    color: blue;
    vertical-align: middle;
    cursor: pointer;
  }
  .label-title {
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
  }
  .button-icon {
    display: inline-block;
    float: right;
  }
</style>